import {
  BaseRecord,
  CreateResponse,
  useHandleNotification,
} from "@refinedev/core";
import { useMarketplaceStore } from "../../../store/useMarketplaceStore";
import { Block } from "@mui/icons-material";
import { AddResponse } from "../../store-security/components/AddRestrictionDialog";
import { ActionButton } from "./ActionButton";

type RestrictionActionProps = {
  title: string;
  description: string;
  endpoint: string;
  keyword: string;
  successMessage: string;
  duplicationErrorMessage: string;
};

export const RestrictionAction = (props: RestrictionActionProps) => {
  const {
    title,
    description,
    endpoint,
    keyword,
    successMessage,
    duplicationErrorMessage,
  } = props;

  const selectedCountry = useMarketplaceStore((state) => state.selectedCountry);
  const handleNotification = useHandleNotification();

  const handleSuccess = (data: CreateResponse<BaseRecord>) => {
    const response = data?.data as AddResponse;
    const savingReports = response.restrictionsSavingReports;

    if (savingReports && savingReports.length > 0) {
      const existsError = savingReports.some(
        (report) => report.countOfExistingRestrictions > 0,
      );

      if (existsError) {
        handleNotification({
          message: duplicationErrorMessage,
          type: "error",
        });
      } else {
        handleNotification({
          message: successMessage,
          type: "success",
        });
      }
    }
  };

  return (
    <ActionButton
      title={title}
      description={description}
      endpoint={endpoint}
      icon={<Block />}
      values={{
        keywords: [keyword],
        marketplaceIds: [selectedCountry?.id],
      }}
      onSuccess={handleSuccess}
    />
  );
};
